'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _contextMenuList = require('./context-menu-list');

var _contextMenuList2 = _interopRequireDefault(_contextMenuList);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./context-menu.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContextMenu = function (_React$Component) {
  _inherits(ContextMenu, _React$Component);

  function ContextMenu(props) {
    _classCallCheck(this, ContextMenu);

    var _this = _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, props));

    _this.state = { opened: false };

    _this.openMenu = _this.openMenu.bind(_this);
    _this.closeMenu = _this.closeMenu.bind(_this);
    return _this;
  }

  _createClass(ContextMenu, [{
    key: 'closeMenu',
    value: function closeMenu() {
      var onClose = this.props.onClose;


      this.setState({ opened: false });

      if (onClose) {
        onClose();
      }
    }
  }, {
    key: 'openMenu',
    value: function openMenu(event) {
      event.stopPropagation();

      var targetClientRect = event.currentTarget.getBoundingClientRect();
      var topPosition = targetClientRect.y + window.pageYOffset;
      var rightPosition = window.innerWidth - (targetClientRect.x + targetClientRect.width);
      var bottomPosition = window.innerHeight - (targetClientRect.y + targetClientRect.height);
      var leftPosition = targetClientRect.x;

      this.setState({
        position: {
          top: topPosition + 'px',
          right: rightPosition + 'px',
          bottom: bottomPosition + 'px',
          left: leftPosition + 'px'
        },
        opened: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          opener = _props.opener,
          horizontalDock = _props.horizontalDock,
          verticalDock = _props.verticalDock;
      var _state = this.state,
          position = _state.position,
          opened = _state.opened;


      var classes = (0, _classnames2.default)('context-menu', 'context-menu--' + verticalDock, 'context-menu--' + horizontalDock, className);

      return _react2.default.createElement(
        'div',
        { className: classes, tabIndex: '0', onClick: this.openMenu },
        opener,
        opened && _reactDom2.default.createPortal(_react2.default.createElement(
          _contextMenuList2.default,
          {
            className: className,
            onClose: this.closeMenu,
            horizontalDock: horizontalDock,
            verticalDock: verticalDock,
            position: position
          },
          children
        ), document.body)
      );
    }
  }]);

  return ContextMenu;
}(_react2.default.Component);

ContextMenu.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  horizontalDock: _propTypes2.default.oneOf(['left', 'right']),
  onClose: _propTypes2.default.func,
  opener: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array]),
  verticalDock: _propTypes2.default.oneOf(['top', 'bottom'])
};

ContextMenu.defaultProps = {
  horizontalDock: 'left',
  onClose: function onClose() {
    return null;
  },
  verticalDock: 'top'
};

exports.default = ContextMenu;